import { ChevronDown } from 'lucide-react'
import { Button } from './button'
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from './dropdown-menu'

export interface FilterDropdownOption {
  value: string
  label: string
  disabled?: boolean
}

export interface FilterDropdownProps {
  label: string
  emptyLabel: string
  options: FilterDropdownOption[]
  selected: ReadonlySet<string>
  onChange: (selected: Set<string>) => void
}

export function FilterDropdown({
  label,
  emptyLabel,
  options,
  selected,
  onChange,
}: FilterDropdownProps) {
  const triggerLabel = selected.size === 0 ? emptyLabel : `${label} · ${selected.size}`

  const toggleOption = (value: string) => {
    const next = new Set(selected)
    if (next.has(value)) next.delete(value)
    else next.add(value)
    onChange(next)
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button type="button" variant="outline" className="h-9 gap-2 whitespace-nowrap">
          {triggerLabel}
          <ChevronDown
            className="size-3.5 text-muted-foreground"
            strokeWidth={1.5}
            aria-hidden="true"
          />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start">
        {options.map((option) => (
          <DropdownMenuCheckboxItem
            key={option.value}
            checked={selected.has(option.value)}
            disabled={option.disabled}
            onCheckedChange={() => toggleOption(option.value)}
          >
            {option.label}
          </DropdownMenuCheckboxItem>
        ))}
        {selected.size > 0 && (
          <>
            <DropdownMenuSeparator />
            <DropdownMenuItem
              className="text-muted-foreground"
              onSelect={() => onChange(new Set())}
            >
              Clear
            </DropdownMenuItem>
          </>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
